var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"color":_vm.checked ? _vm.color : _vm.uncheckedColor,"icon":""},on:{"click":function($event){return _vm.$emit('change', !_vm.checked)}}},[_c('v-icon',{domProps:{"textContent":_vm._s(_vm.checked ? _vm.icon : _vm.uncheckedIcon ?? _vm.icon)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }